module.exports = "/assets/data/639ac8ea885492360b328458ffb7204b-TN37.data.json";